import { Form, Input } from "decorator-form";

import EntitySelect from "common/form/fields/entitySelect/EntitySelect";
import InputType from "common/form/InputType";
import { Entity, Field } from "typegraph";

// tslint:disable:max-classes-per-file

@Entity({many: "Program"})
class Program {
	@Field()
	public id: any;

	@Field()
	public name: string;
}

const programSelect = EntitySelect.registered({entity: Program, type: 'one'}, 'string');

@Form({title: "Program Details Panel Config"})
export default class ProgramDetailsConfig {

	@Input({type: programSelect, title: "Program (if none selected, uses programId page parameter)"})
	public programId: string;

}



// WEBPACK FOOTER //
// ./src/panels/program/config/ProgramDetailsConfig.ts